export function isEdge() {
	const ua = window.navigator.userAgent;
	if (ua.indexOf('Edge/') > 0) {
		return true;
	}
	return false;
}

export function isIE() {
	const ua = window.navigator.userAgent;
	if (ua.indexOf('MSIE ') > 0) {
		// IE 10 and lower
		return true;
	}
	if (ua.indexOf('Trident/') > 0) {
		// IE 11
		return true;
	}
	return false;
}

export function isIOS() {
	const ua = window.navigator.userAgent.toLowerCase();
	if (ua.indexOf('ipad') >= 0 || ua.indexOf('iphone') >= 0 || ua.indexOf('ipod') >= 0) {
		return true;
	}
	if (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1) {
		// after iOS 13, iPad's "desktop" version is enabled by default
		return true;
	}
	return false;
}

export function isMobile() {
	const isMobile = (/iphone|ipod|android|blackberry|opera|mini|windows\sce|palm|smartphone|iemobile/i.test(navigator.userAgent.toLowerCase()));
	if (isMobile) {
		return true;
	}
	return false;
}

export function isTablet() {
	var isTablet = (/ipad|android|android 3.0|xoom|sch-i800|playbook|tablet|kindle/i.test(navigator.userAgent.toLowerCase()));
	if (isTablet) {
		return true;
	}
	return false;
}

export function isMobileOrTablet() {
	if (isMobile() || isTablet()) {
		return true;
	}
	return false;
}

export function isTouchDevice() {
	return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
}

export default {
	isEdge,
	isIE,
	isIOS,
	isMobile,
	isTablet,
	isMobileOrTablet
}
